<template>
  <div :class="classContainer">
    <div class="bg-[#FFECE9] py-[8px] px-[28px] rounded-t text-black font-[500]">
      Varian Produk
    </div>
    <b-table
      :items="items"
      :fields="tableFields"
    >
      <template #cell(no)="row">
        {{ row.index + 1 }}
      </template>
      <template #cell(bundle_component)="row">
        <div v-if="isEmptyComponent(row.item)">
          <div class="text-center text-[#6e6b7b] h-[100px]">
            Tidak ada produk yang terkait
          </div>
        </div>
        <BundleComponentProduct
          v-for="(item, index) in row.item[componentLocation]"
          v-else
          :key="`${item.product_id}-${index}-${row.item.variant_id}`"
          :item="item"
        />
      </template>
    </b-table>
  </div>
</template>

<script>
/**
 * Component untuk menampilkan detail varian produk dalam bundle varian
 * @param {Array} items - Array item varian produk
 */
import { fieldsVariantBundling } from './config'
import BundleComponentProduct from './BundleComponentProduct.vue'

export default {
  components: {
    BundleComponentProduct,
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    componentLocation: {
      type: String,
      default: 'bundle_component',
    },
    classContainer: {
      type: String,
      default: 'border rounded-t w-[80%]',
    },
    additionalFields: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      fieldsVariantBundling,
    }
  },
  computed: {
    tableFields() {
      return [...this.fieldsVariantBundling, ...this.additionalFields]
    },
  },
  methods: {
    /**
     * Mengecek apakah komponen bundle kosong
     * @param {Object} item - Item varian produk
     * @returns {boolean} - True jika komponen bundle kosong, false jika tidak
     */
    isEmptyComponent(item) {
      return !Array.isArray(item[this.componentLocation]) || item[this.componentLocation].length <= 0
    },
  },
}
</script>
